import { useEffect } from 'react';
import axios from 'axios';

// Backend URL'si (örneğin)
const apiUrl = process.env.REACT_APP_API_URL;

function StatVisit(pageId) {
  console.log(pageId)
  useEffect(() => {
    const visitKey = `visited-${pageId}`;
    
    if (!localStorage.getItem(visitKey)) {

      localStorage.setItem(visitKey, 'true');
      axios.post(apiUrl + '/statvisit', { 'pageId': pageId })
        .then(response => {
          
        })
        .catch(error => {
          console.log(error)
        });
    }
  }, [pageId]); // pageId değişirse, useEffect yeniden çalışır
  
}

export default StatVisit;